import { render, staticRenderFns } from "./AllRemindTask.vue?vue&type=template&id=70749314&scoped=true&"
import script from "./AllRemindTask.vue?vue&type=script&lang=js&"
export * from "./AllRemindTask.vue?vue&type=script&lang=js&"
import style0 from "./AllRemindTask.vue?vue&type=style&index=0&id=70749314&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70749314",
  null
  
)

export default component.exports